const passwordValidation = (password) => {
  let numCount = (password.match(/\d/g) || []).length;
  return numCount && password.length > 5 && numCount !== password.length;
};

export default passwordValidation;
